import React, { useEffect } from "react";
import "./VipTabHistory.css";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GETVipBenifitHistory } from "../../../../features/auth/Slice";
import { formatNotifDate } from "../../../../utils/common";


function VipTabHistory() {
  const navigate = useNavigate();


  const dispatch = useDispatch()

  const VipBenifitHistory = useSelector((state) => state.auth.data);


  const fetch = async (page = 1) => {
    await dispatch(GETVipBenifitHistory({ page, per_page: 5 }))
  }

  useEffect(() => { fetch(1) }, [dispatch]);
  return (
    <section className="VipTabHistory">
      {VipBenifitHistory?.data?.map((item) => {
        const values = [];
        let titleColor = "#e2984e"

        // handle amount (coins)
        if (item.amount) {
          values.push({ type: "yellow_coin", val: item.amount });
          titleColor = "#27ae60"
        }

        // handle exp
        if (item.exp) {
          values.push({ type: "exp", val: item.exp });
          titleColor = "#3d77e8"
        }

        return (
          <div key={item.id} className="history_card">
            <div className="history_info">
              <h4 style={{ color: titleColor }}>
                {item.name || ""}
              </h4>
              <p className="history_sub">{item.remark || ""}</p>
              <span className="history_time">
                {formatNotifDate(item.createdAt)}
              </span>
            </div>

            <div className="history_value">
              {values.map((v, idx) => {
                if (v.type === "yellow_coin") {
                  return (
                    <div key={idx} className="bonus_box yellow_bonus_box">
                      <span className="coin_icon">🪙</span> {v.val}
                    </div>
                  );
                }

                if (v.type === "exp") {
                  return (
                    <div key={idx} className="bonus_box">
                      EXP {v.val}
                    </div>
                  );
                }

                return (
                  <span key={idx} className="exp_amt">
                    {v.val}
                  </span>
                );
              })}
            </div>
          </div>
        );
      })}

      <div className="mt-4">
        {VipBenifitHistory?.data?.length > 0 ?
          <Button
            className="btn-register  mb-3"
            onClick={() => navigate("/vip-all-history")}
          >
            View all history
          </Button> :
          <Button
            className="btn-register  mb-3"
            disabled={true}          >
            No History Found
          </Button>
        }
      </div>
    </section>
  );
}

export default VipTabHistory;
